import styled from 'styled-components';
import C from '@assets/themes/colors';
interface IRootProps {
  isSelected?: boolean;
}
export const Root = styled.div`
  font-family: Roboto;
  font-size: 23px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #cccccc;
  margin-top:6px;
`;

export const ButtonContainer = styled.div`
  display:flex;
  width:36px;
  height: 31px;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  //background-color: #122442;
  background-color: ${(props: IRootProps) => props.isSelected ? "#122442" : ""};
  cursor: pointer;
  &:hover {
      background-color: ${C.GRAY}
    }
`;